import React from "react";
import axios from "axios";
import { Icon, notification } from 'antd';


class PaymentInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            users         : [],
            total_user    : 0,
            used_users    : 0,
            showUsers     : "hide",
            showLoadingData : "",
            showData      : "hide"
        }
    }

    componentDidMount(){
        this.handleDataLoaded();

        this.verifyNotifications();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loading_users != this.props.loading_users) {
            this.handleDataLoaded();
        }
    }

    verifyNotifications(){
        if(this.props.show_edited_notification){
            notification.open({
                message: 'NOTIFICATION',
                description: 'User information was successfully edited',
              });
            
            this.props.setEditedNotification(false);
        }
        if(this.props.show_pasword_changed_notification){
            notification.open({
                message: 'NOTIFICATION',
                description: 'Password changed',
              });
              this.props.setPasswordNotification(false);
        }
    }
    
    handleDataLoaded(){
        let self = this;
        if(this.props.loading_users){
            self.setState({
                showLoadingData : "",
                showData      : "hide"
            })
        }else{
            self.setState({
                showLoadingData : "hide",
                showData      : ""
            })
        }
    }

    handleEditUser(user_id){
        this.props.setEditingUser(user_id);
        this.props.activeSection("account","edit","","");
    }
      
    renderUsers(){
        let self = this;
        return  Object.keys(self.props.users).map((key, index) => {
            if (self.props.user_id == self.props.users[key]._id){
                return(
                    <tr key={self.props.users[key]._id}>
                        <td>{self.props.users[key].name + " " + self.props.users[key].lastname }</td>  
                        <td>{self.props.users[key].position}</td>
                        <td>
                        {Object.keys(self.props.roles).map((keyrole, index) => {
                            if(self.props.roles[keyrole]._id === self.props.users[key].sys_roll_id)
                            return (self.props.roles[keyrole].name);
                        })}
                        </td>
                        <td>
                            {Object.keys(self.props.users[key].modules).map((keyhotels, index) => {
                                var str = self.props.users[key].modules[keyhotels].hotel_name;
                                var matches = str.match(/\b(\w)/g); 
                                var acronym = matches.join(''); 
                
                                return  (<span className="table-hotels" key={self.props.users[key].modules[keyhotels].hotel_id}>{acronym}</span>);
                            })} 
                        </td>
                        <td></td>
                        <td>
                            <div className="action-elements">  
                            <a onClick={this.handleEditUser.bind(this,self.props.users[key]._id)} ><img className="action-element-icon" src="../../images/iconos/edit.svg" /></a>
                            {/* <img className="action-element-icon" src="../../images/iconos/cerrar.svg"/> */}
                        </div>
                        </td>
                    </tr> 
                );
            }
        })
    }

    render() {
        return (
            <section>
                
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Account</h1>
                        <h2>Account info</h2>
                    </div>
                </div> 
                <div className="box regular col-md-12">
                   <h3 className="title-roles-h3"> <b>MY INFO</b>
                    </h3>
                    <table className="table-account-info">
                     <thead>
                          <tr className="tr-account-info">
                              <th>NAME</th>
                              <th>POSITION</th>
                              <th>ROLE</th>
                              <th>HOTELS</th>
                              <th>LAST ACCESS</th>
                              <th>ACTIONS</th>
                          </tr>
                     </thead>
                     <tbody className={this.state.showLoadingData}>
                        <tr><td><Icon className={this.state.showLoadingData} type="loading" /></td></tr>
                     </tbody>
                     <tbody className={this.state.showData}>
                        {this.renderUsers()}   
                    </tbody>        
                    </table>
                </div>
            </section>
        )
    }

}

export default PaymentInfo


// WEBPACK FOOTER //
// ./src/Setup/modules/account/views/AccountInfo.js